export enum EntityStoreKey {
  DevFlags = 'DevFlags',
}
